export const COLUMNS = {
  USER: 'user.firstName',
  PAN: 'partialPAN',
  ALIAS: 'alias',
  BUDGET: 'assignedBudget.name',
  STATUS: 'status.code',
  OPTIONS: 'options',
  CARDS: [
    {
      key: 'user.firstName',
      visible: true,
      modifiable: true,
      sortable: true,
      template: '250px',
      name: 'cards_table_header_user'
    },
    {
      key: 'partialPAN',
      visible: true,
      modifiable: true,
      sortable: true,
      template: '130px',
      name: 'cards_table_header_card_id'
    },
    {
      key: 'alias',
      visible: true,
      modifiable: true,
      sortable: true,
      template: '180px',
      name: 'cards_table_header_name'
    },
    {
      key: 'assignedBudget.name',
      visible: true,
      modifiable: true,
      sortable: true,
      template: '180px',
      name: 'cards_table_header_budget'
    },
    {
      key: 'status.code',
      visible: true,
      modifiable: true,
      sortable: true,
      template: '250px',
      name: 'cards_table_header_status'
    },
    {
      key: 'options',
      visible: true,
      modifiable: false,
      template: '20px',
      noHeader: true
    }
  ]
}
